import { observable, action, runInAction } from 'mobx';
export class MarketStore {
    constructor(botStore) {
        this.botStore = botStore;
    }

    @observable market = [];
    @observable hasLoaded = false;

    @action setMarket(market) {
        this.market = market;
    }

    getMarket(base, quote) {
        return this.market[`${base}/${quote}`];
    }

    getByName(name) {
        return Object.values(this.market).filter(a => a.name === name)[0];
    }

    @action async loadMarket() {
        const res = await this.botStore.proxy('ticker');
        runInAction(() => {
            this.setMarket(res);
            this.hasLoaded = true;
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/MarketStore.js